/**
 * mobile
 */
const mobileKey = "yingqiyu_ziubao_shop_mobile_key";

export const saveMobile = mobile => {
    localStorage.setItem(mobileKey, mobile);
}

export const getMobile = () => {
    return localStorage.getItem(mobileKey);
}
